import { render, staticRenderFns } from "./CSVUpload.vue?vue&type=template&id=08a9b588&scoped=true"
import script from "./CSVUpload.vue?vue&type=script&lang=js"
export * from "./CSVUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9b588",
  null
  
)

export default component.exports